import VocabularySearch from 'app/components/layouts/Header/VocabularySearch';
import LanguageDropdown from 'app/components/layouts/Header/LanguageDropdown';
import NavLink, { closeMenu } from 'app/components/layouts/Header/NavLink';
import UserDropdown from 'app/components/layouts/Header/UserDropdown';
import Image from 'app/components/layouts/Image';
import { AppStoreState } from 'app/redux/store';
import routes from 'app/data/routes.json';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import env from '.env.json';
import './styles.css';

const Index = () => {
  const { deviceType } = useSelector((state: AppStoreState) => state.global);

  return (
    <header id="header" style={{ height: 60 }}>
      <div className="main-header" style={{ background: "#0077c8" }}>
        <div className="container-md container-header px-2">
          {(deviceType != 'mobile' || env.ENV == 'dev') &&
            <nav className="navbar navbar-expand p-0" id="navbarTop">
              <Link className="navbar-link ml-3" style={{ marginTop: 2 }} href='/'>
                <Image
                  alt="logo"
                  id="logo-top"
                  width={200}
                  height={53}
                  src="/images/commons/logos/logo.webp"
                />
              </Link>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav position-relative">
                  {/* dropdown menu vocabularies */}
                  <li className='cursor-pointer item-menu dropdown-menu-vocabulary'>
                    <NavLink route={routes.find((route) => route.name === 'vocabulary')} />
                  </li>
                  <li className='item-menu' >
                    <NavLink route={routes.find((route) => route.name === 'grammar')} />
                  </li>
                  <li className='item-menu' >
                    <NavLink route={routes.find((route) => route.name === 'games')} />
                  </li>
                  {/* dropdown menu test */}
                  <li className='cursor-pointer item-menu'>
                    <NavLink route={routes.find((route) => route.name === 'tests')} />
                  </li>
                  {/* dropdown video menu */}
                  <li className='cursor-pointer item-menu'>
                    <NavLink route={routes.find((route) => route.name === 'video')} />
                  </li>
                  <li className='ml-auto cursor-pointer item-menu'>
                    <LanguageDropdown />
                  </li>
                  <li className='cursor-pointer item-menu mx-2'>
                    <UserDropdown />
                  </li>
                  <li className="form-search">
                    <VocabularySearch />
                  </li>
                </ul>
              </div>
            </nav>
          }
          {deviceType != 'desktop' &&
            <div id="menu-mobile" className='position-relative'>
              <div className="d-flex">
                <UserDropdown />
                <div className="my-auto ml-2 item-menu d-block">
                  <LanguageDropdown />
                </div>
              </div>
              <input type="checkbox" className="toggle" aria-label="toggle-menu" />
              <div className="hamburger d-flex justify-content-center flex-wrap"><div></div></div>
              <div className="menu overflow-auto justify-content-center flex-wrap text-center">
                <div>
                  <Link className="nav-link" href='/'>
                    <Image
                      alt="logo"
                      id="logo-top"
                      width={200}
                      height={53}
                      onClick={() => closeMenu()}
                      src="/images/commons/logos/logo.webp"
                    />
                  </Link>
                  <ul className="navbar-nav">
                    <li className="form-search">
                      <VocabularySearch />
                    </li>
                    {
                      routes.map((route) => {
                        return (
                          <li className='item-menu' key={route.path} >
                            <NavLink route={route} />
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </header>
  )
}

export default Index
